(function () {
  if (window.__cardBadgeContrastInitV2) return;
  window.__cardBadgeContrastInitV2 = true;

  var LUMA_THRESHOLD = 145;
  var MIN_REGION = 20;
  var MAX_REGION = 90;

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function regionSize(nw, nh) {
    var r = Math.round(Math.min(nw, nh) * 0.10);
    return clamp(r, MIN_REGION, MAX_REGION);
  }

  function getRects(badgeEl, imgEl) {
    var b = badgeEl.getBoundingClientRect();
    var i = imgEl.getBoundingClientRect();
    return { badge: b, img: i };
  }

  function badgeCenterToImageXY(badgeRect, imgRect, naturalW, naturalH) {
    var cx = badgeRect.left + badgeRect.width / 2;
    var cy = badgeRect.top + badgeRect.height / 2;

    var rx = (cx - imgRect.left) / imgRect.width;
    var ry = (cy - imgRect.top) / imgRect.height;

    rx = clamp(rx, 0, 1);
    ry = clamp(ry, 0, 1);

    return {
      x: Math.round(rx * naturalW),
      y: Math.round(ry * naturalH)
    };
  }

  function sampleLuma(img, sx, sy, sw, sh) {
    var canvas = document.createElement('canvas');
    canvas.width = sw;
    canvas.height = sh;

    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);

    var data = ctx.getImageData(0, 0, sw, sh).data;
    var sum = 0;
    var count = 0;

    for (var i = 0; i < data.length; i += 4) {
      var a = data[i + 3];
      if (a < 32) continue;

      var r = data[i];
      var g = data[i + 1];
      var b = data[i + 2];

      var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
      sum += luma;
      count++;
    }

    if (!count) return 255;
    return sum / count;
  }

  function applyBadgeClass(badgeEl, luma, ok) {
    badgeEl.classList.remove('badge-contrast--light', 'badge-contrast--dark', 'badge-contrast--fallback');

    if (!ok) {
      badgeEl.classList.add('badge-contrast--fallback');
      return;
    }

    var useLight = luma < LUMA_THRESHOLD;
    badgeEl.classList.add(useLight ? 'badge-contrast--light' : 'badge-contrast--dark');
  }

  function updateFromSrc(cardEl, imgEl) {
    var badgeWrap = cardEl.querySelector('.card__badge.badge-contrast-auto');
    if (!badgeWrap) return;

    // don't fight your existing Swiper logic
    if (cardEl.querySelector('.swiper.cardSlider')) return;

    var badgeEl = badgeWrap.querySelector('.badge');
    if (!badgeEl || !imgEl) return;

    var src = imgEl.currentSrc || imgEl.src;
    if (!src) return;

    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.decoding = 'async';
    probe.src = src;

    function run() {
      try {
        var nw = probe.naturalWidth;
        var nh = probe.naturalHeight;
        if (!nw || !nh) return;

        var rects = getRects(badgeWrap, imgEl);
        var xy = badgeCenterToImageXY(rects.badge, rects.img, nw, nh);

        var r = regionSize(nw, nh);
        var sx = clamp(Math.round(xy.x - r / 2), 0, nw - r);
        var sy = clamp(Math.round(xy.y - r / 2), 0, nh - r);

        var luma = sampleLuma(probe, sx, sy, r, r);
        applyBadgeClass(badgeEl, luma, true);
      } catch (e) {
        // CORS/tainted canvas/etc.
        applyBadgeClass(badgeEl, 0, false);
      }
    }

    if (probe.complete && probe.naturalWidth) {
      run();
    } else {
      probe.addEventListener('load', run, { once: true });
      probe.addEventListener('error', function () {
        applyBadgeClass(badgeEl, 0, false);
      }, { once: true });
    }
  }

  function initCard(cardEl) {
    if (cardEl.dataset.badgeContrastInit === '1') return;
    cardEl.dataset.badgeContrastInit = '1';

    var media = cardEl.querySelector('.card__media');
    if (!media) return;

    var imgs = media.querySelectorAll('img');
    if (!imgs.length) return;

    var rolloverWrap = media.querySelector('.media--hover-effect.rollover');

    // initial
    updateFromSrc(cardEl, imgs[0]);

    // update on image load (lazy)
    imgs.forEach(function (img) {
      img.addEventListener('load', function () {
        // re-evaluate using whichever image is currently relevant
        if (rolloverWrap && imgs.length >= 2 && rolloverWrap.matches(':hover')) {
          updateFromSrc(cardEl, imgs[1]);
        } else {
          updateFromSrc(cardEl, imgs[0]);
        }
      }, { passive: true });
    });

    // rollover hover swap
    if (rolloverWrap && imgs.length >= 2) {
      rolloverWrap.addEventListener('mouseenter', function () {
        updateFromSrc(cardEl, imgs[1]);
      });
      rolloverWrap.addEventListener('mouseleave', function () {
        updateFromSrc(cardEl, imgs[0]);
      });
      rolloverWrap.addEventListener('focusin', function () {
        updateFromSrc(cardEl, imgs[1]);
      });
      rolloverWrap.addEventListener('focusout', function () {
        updateFromSrc(cardEl, imgs[0]);
      });
    }

    // resize can change badge position over image
    window.addEventListener('resize', function () {
      if (rolloverWrap && imgs.length >= 2 && rolloverWrap.matches(':hover')) {
        updateFromSrc(cardEl, imgs[1]);
      } else {
        updateFromSrc(cardEl, imgs[0]);
      }
    }, { passive: true });
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.card-wrapper .card').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  // Covers cases where recommendations/filters inject cards without section events
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes && m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.card-wrapper, .card')) initAll(node);
        if (node.querySelectorAll) initAll(node);
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
